<template>
  <div class="d-none d-xl-block">
    <div 
      id="xit-fb-gripbox" 
      data-type="xitFbGrip"
      class="xit-fb-gripbox d-none"
      @dblclick.stop="fadeInDockmenu"
    >
      <span class="btn btn-icon btn-danger">
        <i class="fa fa-grip-horizontal fa-lg"></i>
      </span>
    </div>

    <div id="xit-fb-dockmenu" class="xit-fb-dockmenu" data-type="fbDockmenu">
      <div 
        class="fb-dockmenu-header d-none"
        @dblclick="fadeOutDockmenu"
      >
        <i class="fa fa-grip-horizontal fa-lg"></i>
      </div>
      <div 
        id="fb-dockmenu-content"  
        class="fb-dockmenu-content"
      >
        <elements />
      </div>
      <div class="d-none justify-content-center mt-2">
        <img v-if="!! faviconSrc" :src="faviconSrc" width="40" height="40"/>
      </div>
    </div>
  </div>

</template>

<script>
import Elements from './Elements'

export default {
  name: 'Card',
  components: {
    Elements,
  },

  props: {
    faviconSrc: {
      type: String,
      required: true,
    }
  },

  methods: {
    fadeOutDockmenu(event) {
      $('#xit-fb-dockmenu').fadeOut(100)

      const fbWidth = $('#xit-flow-builder').width()
      const xitFbGripbox = $('#xit-fb-gripbox').width()

      let gripboxPosition = ''
      if (parseInt(event.clientX + xitFbGripbox, 10) >= fbWidth) {
        gripboxPosition = parseInt(fbWidth - (xitFbGripbox + 10), 10)        
      } else {
        gripboxPosition = event.clientX
      }

      $('#xit-fb-gripbox')
        .removeClass('d-none')
        .css({ left: gripboxPosition, top: event.clientY })
        .fadeIn(500)
        
    },

    // eslint-disable-next-line
    fadeInDockmenu(event) {
      $('#xit-fb-gripbox').fadeOut(50)

      $("#xit-fb-dockmenu")
        .css({ top: 0, left: 0 })
        .fadeIn(500)
    },    
  },

  mounted() {
    $('#xit-fb-gripbox').draggable({
      containment: '#xit-flow-builder',
      scroll: false,
    })

    $('#xit-fb-dockmenu').draggable({
      containment: '#xit-flow-builder',
      cancel: '.tabs-content-component',
      scroll: false,
    })    
  },

  beforeDestroy() { // eslint-disable-line
    const gripboxElement = $('#xit-fb-gripbox')
    const isGripboxDraggable = gripboxElement.hasClass('ui-draggable')

    if (isGripboxDraggable) {
      gripboxElement.draggable('destroy')
    }

    const dockmenuElement = $('#xit-fb-dockmenu')
    const isDockmenuDraggable = dockmenuElement.hasClass('ui-draggable')

    if (isDockmenuDraggable) {
      dockmenuElement.draggable('destroy')
    }
  },
}
</script>

<style scoped>
.xit-fb-gripbox {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 302;
}
.xit-fb-dockmenu {
  position: absolute;
  top: 0px;
  left:0;
  width: auto;
  height: 60px;
/*  background-color: #fff;*/
  z-index: 301;
/*  border: 0.5px solid #cddeed;*/
}
.fb-dockmenu-header {
  display: flex;
/*  justify-content: center;*/
  padding: 10px;
  background: #dee3e66b;
}
.fb-dockmenu-header .svg-inline--fa {
  font-size: 1rem;
  color: #0D8BF1;
  font-weight: normal;
  cursor: pointer;
}
.fb-dockmenu-content {
  margin: 0px;
  padding: 0px;
}
</style>